<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/task/review-plan/table' }">复核目标</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">{{ form.id ? '修改复核目标' : '添加复核目标' }}</template>
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="140px"
        size="medium"
        class="form-content-half"
      >
        <el-form-item label="复核人" prop="admin_id">
          <remote-select
            placeholder="请输入用户名称搜索"
            v-model="form.admin_id"
            id-key="id"
            label-key="name"
            value-key="id"
            keyword-key="name"
            :query-request="queryPlatformUsers"
            :find-request="findPlatformUser"
            :disabled="!!form.id"
            clearable
          />
        </el-form-item>

        <el-form-item label="日期" prop="plan_date">
          <el-date-picker
            v-model="form.plan_date"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择"
            :disabled="!!form.id"
            clearable
            class="width-max"
            align="right"
          />
        </el-form-item>

        <el-form-item label="目标数" prop="review_target">
          <el-input
            v-model="form.review_target"
            placeholder="请输入目标单量"
            type="number"
            :min="0"
            class="width-max"
          />
        </el-form-item>

        <el-row class="form-panel">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="$router.back()">返回</el-button>
        </el-row>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { getPlatformUsersIndex, getPlatformUsersDetail } from '@/views/platform-user/platform-user.api'

export default {
  name: 'ReviewPlanFormPage',
  data () {
    return {
      formRules: {
        admin_id: [{ required: true, message: '请选择复核人', trigger: 'change' }],
        plan_date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        review_target: [
          {
            validator: (rule, value, callback) => {
              const v = value === null || value === undefined || value === '' ? null : Number(value)
              if (v === null || Number.isNaN(v) || v < 0) {
                callback(new Error('请输入正确的目标单量（>=0）'))
                return
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      },
      form: {
        id: null,
        admin_id: null,
        plan_date: null,
        review_target: null,
      },
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  methods: {
    queryPlatformUsers (params) {
      return getPlatformUsersIndex(params || {}).then((res) => {
        const body = res && res.data
        let list = []
        if (body && body.detail && Array.isArray(body.detail.data)) {
          list = body.detail.data
        } else if (body && Array.isArray(body.data)) {
          list = body.data
        }
        return { data: { data: list } }
      })
    },
    findPlatformUser (params) {
      return getPlatformUsersDetail(params || {}).then((res) => {
        const body = res && res.data
        let item = body
        if (body && body.detail) {
          const candidate = body.detail
          // 有的接口 detail 在内，有的接口可能直接在根层携带字段
          item = (candidate && (candidate.id != null || candidate.name != null)) ? candidate : body
        }
        return { data: item }
      })
    },
    onLoad () {
      const id = this.$route.params && this.$route.params.id ? this.$route.params.id : null
      if (!id) return

      this.form.id = id
      request.page('getReviewPlan', { id }).then(({ data }) => {
        // 后端字段：admin_id / plan_date / review_target
        filter.setLoop(this.form, data)
        this.form.admin_id = data.admin_id != null ? String(data.admin_id) : null
        this.form.review_target = data.review_target != null ? Number(data.review_target) : null
      })
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return

        const payload = {
          admin_id: parseInt(this.form.admin_id, 10),
          plan_date: this.form.plan_date,
          review_target: parseInt(this.form.review_target, 10),
        }

        if (this.form.id) {
          request.common('updateReviewPlan', { id: this.form.id, review_target: payload.review_target })
            .then(() => {
              this.$message.success('保存成功')
              this.$router.push({ path: '/task/review-plan/table' })
            })
        } else {
          request.common('createReviewPlan', payload)
            .then(() => {
              this.$message.success('创建成功')
              this.$router.push({ path: '/task/review-plan/table' })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
/* 表单项内容区域最大宽度50%（与其他表单页面保持一致） */
.form-content-half .el-form-item__content {
  max-width: 50%;
}

/* 表单底部操作面板（与其他表单页面保持一致） */
.form-panel {
  margin: 20px 0 0;
  width: 100%;
  justify-content: flex-end;
}
</style>




// WEBPACK FOOTER //
// src/views/task/pages/ReviewPlanFormPage.vue